import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { GenreOut, GenresOut, LibraryCreatedProductRequest, PerformerOut } from '../../../../../store/apiLibx';
import { AdditionalProps } from '../../../../../api/local-content/collection/product/useUpdateForm';

export function checkForInvalidProductData(product: AdditionalProps) {
    const errorFields = {
        'Series Number': product.seriesNumberError,
        'Number of Pages': product.pagesError,
        'Release Date': product.releaseDateError
    };

    const invalidFields: string[] = [];

    for (const key in errorFields) {
        if (errorFields.hasOwnProperty(key)) {
            if (errorFields[key] === true) {
                invalidFields.push(key);
            }
        }
    }
    return invalidFields;
}

export function checkForIncompleteProductData(
    product: LibraryCreatedProductRequest,
    selectedGenres: { localGenres: GenreOut[]; standardGenres: GenreOut[] },
    genreData: GenresOut
) {
    const mandatoryFields: Record<string, string> = {
        titleWithoutPrefix: 'Title without prefix',
        authorIds: 'Authors',
        teaser: 'Teaser',
        description: 'Description',
        productFormat: 'Format',
        pages: 'Number of Pages',
        releaseDate: 'Release Date',
        ageCategory: 'Age Category',
        ageGroup: 'Age Group',
        fiction: 'Fiction/Non-Fiction',
        explicit: 'Explicit',
        publisherImprint: 'Published By',
        genreCategoryId: 'Local Content Category',
        languageCode: 'Language'
    };

    const mandatoryFieldsDependentOnMarcRecord = {
        marcTitleWithoutPrefix: 'MARC Title',
        marcSubjectHeadings: 'MARC Subject Headings'
    };

    const mandatoryFieldsGenres = {
        localGenres: 'Local Content Genres',
        standardGenres: 'Standard BorrowBox Genres'
    };

    const errorFieldsMandatory = Object.keys(mandatoryFields).filter(element => {
        const field = product[element];
        return filterFields(field);
    });

    const errorFieldsMandatoryDependentOnMarcRecord = Object.keys(mandatoryFieldsDependentOnMarcRecord).filter(
        element => product.enableMarcRecord && filterFields(product[element])
    );

    let errorFieldsMandatoryGenres: string[] = [];
    if (!errorFieldsMandatory.includes('genreCategoryId')) {
        errorFieldsMandatoryGenres = Object.keys(mandatoryFieldsGenres).filter(element => {
            const isGenreMandatory = genreData[element] ? genreData[element].mandatory : false;
            const field = selectedGenres && selectedGenres[element];
            return isGenreMandatory && filterFields(field);
        });
    }

    const errorFields: string[] = [];

    errorFieldsMandatory.forEach(element => {
        errorFields.push(mandatoryFields[element]);
    });

    errorFieldsMandatoryDependentOnMarcRecord.forEach(element => {
        errorFields.push(mandatoryFieldsDependentOnMarcRecord[element]);
    });

    errorFieldsMandatoryGenres.forEach(element => {
        errorFields.push(mandatoryFieldsGenres[element]);
    });

    return errorFields;
}

function filterFields(field: any) {
    return (['array', 'object', 'string'].includes(typeof field) || isNil(field)) && isEmpty(field);
}

export function checkForIncompletePerformerData(performer: PerformerOut) {
    const mandatoryFields = [
        {
            field: 'lastName',
            name: 'Last Name'
        },
        { field: 'country', name: 'Country' },
        {
            field: 'biography',
            name: 'Biography'
        }
    ];

    return mandatoryFields.filter(field => filterFields(performer[field.field])).map(field => field.name);
}
